import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { productPropType } from '../../prop-types/storefront';
import { reviewsPropType } from '../../prop-types/yotpo';

/**
 * JSON-LD provides semantic information about objects to search engines, making
 * it easier for them to understand what is included in the page and hopefully
 * improve SEO ranking. This component merges data about products from
 * Contentful, Shopify and Yotpo into a blob of JSON-LD which it then inserts
 * into the header of the document.
 */
const GlowforgeProductJsonLd = ({
  jsonLdTemplate,
  product,
  reviews,
}) => {
  if (!jsonLdTemplate || !product || !reviews) {
    return null;
  }

  const template = _.template(jsonLdTemplate);
  let compiled = '';

  try {
    compiled = template({
      product,
      reviews,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
    return null;
  }

  return (
    <Helmet>
      <script type='application/ld+json'>{compiled}</script>
    </Helmet>
  );
};

GlowforgeProductJsonLd.propTypes = {
  jsonLdTemplate: PropTypes.string,
  product: productPropType,
  reviews: reviewsPropType,
};

GlowforgeProductJsonLd.defaultProps = {
  jsonLdTemplate: null,
  product: null,
  reviews: null,
};

export default GlowforgeProductJsonLd;
